import { render, staticRenderFns } from "./notificaciones.vue?vue&type=template&id=0b037484"
import script from "./notificaciones.vue?vue&type=script&lang=js"
export * from "./notificaciones.vue?vue&type=script&lang=js"
import style0 from "./notificaciones.vue?vue&type=style&index=0&id=0b037484&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports